var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewcalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25033 0.583252V1.74992H8.75033V0.583252H9.91699V1.74992H12.2503C12.405 1.74992 12.5534 1.81138 12.6628 1.92077C12.7722 2.03017 12.8337 2.17854 12.8337 2.33325V11.6666C12.8337 11.8213 12.7722 11.9697 12.6628 12.0791C12.5534 12.1885 12.405 12.2499 12.2503 12.2499H1.75033C1.59562 12.2499 1.44724 12.1885 1.33785 12.0791C1.22845 11.9697 1.16699 11.8213 1.16699 11.6666V2.33325C1.16699 2.17854 1.22845 2.03017 1.33785 1.92077C1.44724 1.81138 1.59562 1.74992 1.75033 1.74992H4.08366V0.583252H5.25033ZM11.667 6.41659H2.33366V11.0833H11.667V6.41659ZM4.08366 2.91659H2.33366V5.24992H11.667V2.91659H9.91699V4.08325H8.75033V2.91659H5.25033V4.08325H4.08366V2.91659Z",
    fill: "#224A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcalender);
export default __webpack_public_path__ + "static/media/newcalender.dc97d7c2a0790f6ea9d8bcf5d4163641.svg";
export { ForwardRef as ReactComponent };